(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eo-design-system"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const open=event.target.closest('[data-eo-open]');
  if(open){const dialog=document.getElementById(open.dataset.eoOpen);if(dialog&&typeof dialog.showModal==='function'){dialog.showModal();}return;}
  const close=event.target.closest('[data-eo-close]');
  if(close){close.closest('dialog')?.close();return;}
  if(event.target.tagName==='DIALOG'){const rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom){event.target.close();}return;}
  const toggle=event.target.closest('[data-eo-toggle]');
  if(toggle){const panel=document.getElementById(toggle.dataset.eoToggle);if(panel){panel.hidden=!panel.hidden;toggle.setAttribute('aria-expanded',String(!panel.hidden));}return;}
  const thumb=event.target.closest('[data-eo-image]');
  if(thumb){const root=thumb.closest('[data-eo-product]');const photo=root?.querySelector('.eo-gallery-image');if(photo){photo.src=thumb.dataset.eoImage;photo.removeAttribute('srcset');photo.alt=thumb.dataset.eoAlt;root.querySelectorAll('[data-eo-image]').forEach(button=>button.setAttribute('aria-pressed',String(button===thumb)));const dialog=document.getElementById(root.querySelector('[data-eo-open]').dataset.eoOpen);const zoom=dialog?.querySelector('.eo-zoom-image');if(zoom){zoom.src=thumb.dataset.eoImage;zoom.removeAttribute('srcset');zoom.alt=thumb.dataset.eoAlt;}}return;}
  const step=event.target.closest('[data-eo-qty]');
  if(step){const input=step.closest('.eo-quantity')?.querySelector('input');if(input){if(Number(step.dataset.eoQty)>0){input.stepUp();}else{input.stepDown();}input.dispatchEvent(new Event('change',{bubbles:true}));}}
});
document.addEventListener('change',function(event){
  if(event.target.matches('[data-eo-sort]')){event.target.form.requestSubmit();}
  if(event.target.matches('[data-eo-variant]')){const url=new URL(window.location.href);url.searchParams.set('variant',event.target.value);window.location.assign(url.toString());}
  if(event.target.matches('#AtelierCart input[name="updates[]"]')){const notice=document.querySelector('[data-eo-cart-update]');if(notice)notice.hidden=false;}
});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){document.querySelectorAll('.eo-category-menu[open]').forEach(menu=>{menu.removeAttribute('open');menu.querySelector('summary').focus();});}});
document.addEventListener('click',function(event){document.querySelectorAll('.eo-category-menu[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open');});});
  } catch(e) { console.error(e); }
})();

})();
